import React, { Component } from "react";

// A sentence with one editable value embedded in it.
//
// Used for the Employer Brand Visibility slide, where the date the certification
// runs to is agreed per client and so cannot be derived from the report year.
// The surrounding copy stays a translated string containing a {date} marker; only
// the value itself is stored, under `name`, like the other editable slides.
//
// props:
//   template     translated sentence containing "{date}" (may contain HTML)
//   name         content key the value is stored under
//   value        current value
//   placeholder  shown while empty, editing only
//   editable     certifier is allowed to edit
//   onChange     ReportBase._contentOnChange
export default class V2EditableSentence extends Component {
  _onBlur = (event) => {
    const value = event.target.innerText.trim();

    if (value !== this.props.value) {
      this.props.onChange({
        target: { name: this.props.name, value },
      });
    }
  };

  // The node is uncontrolled while focused, so React must not re-render it and
  // move the caret. Same guard as V2EditableCards.
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.editable !== this.props.editable ||
      nextProps.template !== this.props.template ||
      (document.activeElement !== this.node &&
        nextProps.value !== this.props.value)
    );
  }

  render() {
    const { template, value, placeholder, editable } = this.props;
    const [before, after] = String(template).split("{date}");

    return (
      <p>
        <span dangerouslySetInnerHTML={{ __html: before }} />
        {editable ? (
          <strong
            ref={(node) => (this.node = node)}
            className="report-v2__editable-text report-v2__editable-inline"
            contentEditable
            suppressContentEditableWarning
            data-placeholder={placeholder}
            onBlur={this._onBlur}
          >
            {value}
          </strong>
        ) : (
          <strong>{value}</strong>
        )}
        {after !== undefined && (
          <span dangerouslySetInnerHTML={{ __html: after }} />
        )}
      </p>
    );
  }
}
